{
  "WALLBOARD": {
    "LOADING": "A carregar filas telefónicas...",
    "NO_QUEUES": "Não foram encontradas filas telefónicas.",
    "NO_AGENTS": "Não há agentes online nesta fila.",
    "UNKNOWN_CALLER": "Chamador desconhecido",
    "STATUS": "Estado",
    "TIME": "Hora",
    "AGENT": "Agente",
    "EXTENSION": "Extensão",
    "READY": "Agentes prontos",
    "ON_CALL": "Agentes em chamada",
    "PAUSED": "Agentes em pausa",
    "WAITING": "Chamadas em espera",
    "MISSED_CALLS": "Chamadas perdidas",
    "HANDLED_CALLS": "Chamadas recebidas atendidas",
    "OUTBOUND_CALLS": "Chamadas efetuadas atendidas",
    "AVAILABILITY": "Disponibilidade",
    "AVAILABILITY_TOOLTIP": "Percentagem de chamadas recebidas atendidas pelos agentes (chamadas que foram atendidas)",
    "AGENTS_COUNT": "({onCall} em chamada / {total} no total)",
    "NO_AVAILABLE": "(ninguém online)",
    "WAITING_CALLERS_COUNT": "{count} em espera",
    "CALLER": "Chamador",
    "NUMBER": "Número",
    "WAIT_TIME": "Tempo de espera",
    "ACTION": "Ação",
    "PICKUP_CALL": "Atender",
    "PICKUP_SUCCESS": "Pedido para atender a chamada enviado com sucesso.",
    "PICKUP_ERROR": "Não foi possível atender a chamada. Tente novamente.",
    "PICKUP_DISABLED_TOOLTIP": "Não pode atender uma chamada enquanto está numa chamada ou offline.",
    "CHAT_STATUS": {
      "NO_ACCESS": "Sem acesso"
    },
    "PHONE_STATUS": {
      "NO_ACCESS": "Sem acesso"
    }
  }
}
